import { FAQ, SelectionOfPsychologistsItem } from "components/FAQ"

const FAQ_ITEMS = [
    {
        title: "Что делать с этими психологами",
        content: (
            <span>
                Изучите предлагаемые профили. Посмотрите, с&nbsp;чем работает специалист,
                подходит&nbsp;ли вам его ценник и&nbsp;месторасположение. Для того чтобы увидеть
                более полную информацию, кликните по&nbsp;карточке&nbsp;&mdash; откроется
                расширенный профиль с&nbsp;данными об&nbsp;образовании и&nbsp;прямой речью психолога
                о&nbsp;себе.
                <br />
                Если вы&nbsp;выбрали кандидата, который вам понравился, нажмите &laquo;Написать
                сообщение&raquo;, чтобы договориться о&nbsp;консультации.
            </span>
        ),
    },
    {
        title: "Почему нельзя связаться напрямую",
        content: (
            <span>
                Для этого несколько причин.
                <br />
                Во-первых, мы&nbsp;тщательно отбираем специалистов в&nbsp;базу: используется
                специальная методика тестирования, затрачивается время на&nbsp;проверку кандидатов.
                Найти хорошего специалиста очень сложно! Поэтому наша база&nbsp;&mdash; предмет
                нашей гордости и&nbsp;одновременно наша интеллектуальная собственность.
                <br />
                Во-вторых, для того чтобы мониторить уровень оказания услуг, например, факт
                и&nbsp;время ответа на&nbsp;заявку, нам нужно, чтобы коммуникация осуществлялась
                через нас. Надеемся на&nbsp;ваше понимание.{" "}
            </span>
        ),
    },
    {
        title: "Почему именно эти психологи",
        content: (
            <span>
                После того как вы&nbsp;ответили на&nbsp;вопросы анкеты и&nbsp;отметили все проблемы,
                которые вас беспокоят, система выделяет среди них ключевые. На&nbsp;основе этого
                запроса подбираются специалисты, наиболее эффективно работающие с&nbsp;данными
                ситуациями. Их&nbsp;мы&nbsp;и&nbsp;показываем вам.{" "}
            </span>
        ),
    },
    {
        title: "Почему у психологов нет отзывов",
        content: (
            <span>
                Отзывы&nbsp;&mdash; это условная гарантия качества в&nbsp;мире психотерапии. Если
                психолог будет стремиться получать отзывы от&nbsp;клиентов, это может влиять
                на&nbsp;его работу, что противоречит этике. Также у&nbsp;всех клиентов разные
                случаи, разные личные запросы, поэтому отличный отзыв от&nbsp;одного клиента
                совершенно не&nbsp;гарантирует положительного результата другому.
                <br />
                То, что психолог зарегистрирован на&nbsp;сайте Alter, уже означает, что
                он&nbsp;прошел многоступенчатую проверку и&nbsp;мы&nbsp;верим в&nbsp;качество его
                работы. Дальше следует выбирать по&nbsp;интересующим вас параметрам и&nbsp;личным
                предпочтениям.
            </span>
        ),
    },
    {
        title: "Мне никто не понравился",
        content: (
            <span>
                Такое возможно.
                <br />
                Первый вариант: при заполнении анкеты вы&nbsp;отметили слишком много волнующих
                вопросов, а&nbsp;также не&nbsp;совсем точно оценили степень
                их&nbsp;&laquo;волнительности&raquo;. В&nbsp;этом случае системе сложно распознать,
                что для вас имеет первостепенную важность, и&nbsp;психологи могут быть подобраны
                не&nbsp;совсем точно. Попробуйте пройти анкету еще раз, но&nbsp;отвечать более
                вдумчиво и&nbsp;взвешенно. Посмотрите, изменятся&nbsp;ли результаты.
                <br />
                Второй вариант: психологи не&nbsp;устраивают вас по&nbsp;каким-то другим
                параметрам&nbsp;&mdash; стоимости сеанса, опыту или просто не&nbsp;нравятся
                на&nbsp;интуитивном уровне. Это совершенно нормально. В&nbsp;этом случае
                вы&nbsp;можете перейти в&nbsp;полный каталог наших специалистов (последняя карточка
                в&nbsp;выдаче), отфильтровать их&nbsp;по&nbsp;цене и&nbsp;специализации
                и&nbsp;посмотреть всех.{" "}
            </span>
        ),
    },
]

export function FAQContainer() {
    return (
        <div className="columns">
            <div className="column">
                <FAQ
                    renderProp={FAQ_ITEMS.map((faqItem, index) => (
                        <SelectionOfPsychologistsItem faqItem={faqItem} key={index} />
                    ))}
                />
            </div>
        </div>
    )
}
